import { NgModule } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { AboutComponent } from './about/about.component';
import {RouterModule, Routes} from '@angular/router';
import { HowworkComponent } from './howwork/howwork.component';
import { SupportComponent } from './support/support.component';
import { ComingComponent } from './coming/coming.component';
import { MemberComponent } from './member/member.component';
import { FindSavingComponent } from './find-saving/find-saving.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AdminComponent } from './admin/admin.component';
import { TransacitionComponent } from './transacition/transacition.component';
import { BudgetComponent } from './budget/budget.component';
import { DemoComponent } from './demo/demo.component';

import { TranscationDetailsComponent } from './transcation/transcation-details/transcation-details.component';
import { TranscationListComponent } from './transcation/transcation-list/transcation-list.component';
import { CreateTranscationComponent } from './transcation/create-transcation/create-transcation.component';
import { SalaryDetailsComponent } from './salary/salary-details/salary-details.component';
import { SalaryListComponent } from './salary/salary-list/salary-list.component';
import { CreateSalaryComponent } from './salary/create-salary/create-salary.component';

const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'Home', component: HomeComponent},
  {path: 'about', component: AboutComponent},
  {path: 'how-work', component: HowworkComponent},
  {path: 'support', component: SupportComponent},
  {path: 'demo', component: DemoComponent},
  {path: 'login', component: LoginComponent},
  {path: 'signup', component: SignupComponent},
  {path: 'footer', component: FooterComponent},
  {path: 'coming', component: ComingComponent},
  {path: 'member', component: MemberComponent},
  {path: 'find-saving', component: FindSavingComponent},
  {path: 'admin', component: AdminComponent},
  {path: 'transacition', component: TransacitionComponent},
  {path: 'budget', component: BudgetComponent},
  {path: '**', component: PageNotFoundComponent},
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(appRoutes)]
})
export class AppRoutingModule { }
